import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material';
import { LocationEnvironmentApi } from '@api/location-environment/location-environment.api';
import { LocationSectorApi } from '@api/location-sectors/location-sectors.api';
import { ActionTypeEnum } from '@core/components/fc-tree-view/fc-tree.types';
import { TranslateService } from '@ngx-translate/core';
import { DialogEquipmentService } from 'app/main/equipments/dialog/dialog-equipments.service';
import { DialogLocationEnvironmentComponent } from 'app/main/locations/dialogs/dialog-location-environment/dialog-location-environment.component';
import { DialogLocationSectorComponent } from 'app/main/locations/dialogs/dialog-location-sector/dialog-location-sector.component';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
import * as i2 from "../../../../../core/api/location-sectors/location-sectors.api";
import * as i3 from "../../../../../core/api/location-environment/location-environment.api";
import * as i4 from "../../../../equipments/dialog/dialog-equipments.service";
import * as i5 from "@ngx-translate/core";
var TabLinksService = /** @class */ (function () {
    function TabLinksService(matDialog, locationSectorApi, locationEnvironmentApi, dialogEquipmentService, translateService) {
        this.matDialog = matDialog;
        this.locationSectorApi = locationSectorApi;
        this.locationEnvironmentApi = locationEnvironmentApi;
        this.dialogEquipmentService = dialogEquipmentService;
        this.translateService = translateService;
        this.unlinkItem$ = new Subject();
        this.reloadItem$ = new Subject();
    }
    TabLinksService.prototype.linkSectorsEnvironmentsEquipments = function (params) {
        var _this = this;
        var sectors = params.sectors, environments = params.environments, equipments = params.equipments;
        var environmentsBySectorMap = {};
        environments.forEach(function (environment) {
            environmentsBySectorMap[environment.locationSector.id] = environmentsBySectorMap[environment.locationSector.id] || [];
            environmentsBySectorMap[environment.locationSector.id].push(environment);
        });
        var unlinkedEquipments = [];
        var equipmentsBySectorMap = {};
        var equipmentsByEnvironmentMap = {};
        equipments.forEach(function (equipment) {
            if (equipment.locationSector) {
                if (equipment.locationEnvironment) {
                    equipmentsByEnvironmentMap[equipment.locationEnvironment.id] = equipmentsByEnvironmentMap[equipment.locationEnvironment.id] || [];
                    equipmentsByEnvironmentMap[equipment.locationEnvironment.id].push(equipment);
                }
                else {
                    equipmentsBySectorMap[equipment.locationSector.id] = equipmentsBySectorMap[equipment.locationSector.id] || [];
                    equipmentsBySectorMap[equipment.locationSector.id].push(equipment);
                }
            }
            else {
                unlinkedEquipments.push(equipment);
            }
        });
        unlinkedEquipments.sort(this.sortArchivedThenByName);
        sectors.sort(this.sortArchivedThenByName);
        sectors.forEach(function (sector) {
            sector.equipments = equipmentsBySectorMap[sector.id] || [];
            sector.equipments.sort(_this.sortArchivedThenByName);
            sector.locationEnvironments = environmentsBySectorMap[sector.id] || [];
            sector.locationEnvironments.sort(_this.sortArchivedThenByName);
            sector.locationEnvironments.forEach(function (environment) {
                environment.equipments = equipmentsByEnvironmentMap[environment.id] || [];
                environment.equipments.sort(_this.sortArchivedThenByName);
            });
        });
        return {
            sectors: sectors,
            unlinkedEquipments: unlinkedEquipments
        };
    };
    TabLinksService.prototype.formatSectors = function (params) {
        var _this = this;
        var sectors = params.sectors, recurrence = params.recurrence, isViewMode = params.isViewMode;
        return (sectors || []).map(function (sector) {
            var sectorItem = {
                id: sector.id,
                text: sector.name,
                description: sector.description,
                archived: sector.archived,
                archivedText: _this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.ARCHIVED'),
                icon: 'sector',
                metadata: 'sector',
                original: sector,
                action: {
                    type: ActionTypeEnum.menu,
                    buttons: [
                        {
                            text: _this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.MENU.VIEW_SECTOR'),
                            icon: 'wysiwyg',
                            color: '#676767',
                            action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.openLocationSectorDialog(sector.id)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        },
                        {
                            text: _this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.MENU.UNLINK_SECTOR'),
                            icon: 'delete',
                            color: '#676767',
                            disabled: Boolean(recurrence && recurrence.id) || isViewMode,
                            action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    this.unlinkItem$.next({
                                        id: sector.id,
                                        formControlName: 'locationSectors'
                                    });
                                    return [2 /*return*/];
                                });
                            }); }
                        }
                    ]
                }
            };
            sectorItem.children = tslib_1.__spread(_this.formatEnvironments({
                environments: sector.locationEnvironments,
                parent: sectorItem,
                isViewMode: isViewMode,
                recurrence: recurrence
            }), _this.formatEquipments({
                equipments: sector.equipments,
                recurrence: recurrence,
                isViewMode: isViewMode,
                parent: sectorItem
            }));
            return sectorItem;
        });
    };
    TabLinksService.prototype.formatUnlinkedEquipments = function (params) {
        var recurrence = params.recurrence, unlinkedEquipments = params.unlinkedEquipments, isViewMode = params.isViewMode;
        var formattedEquipments = this.formatEquipments({ equipments: unlinkedEquipments, recurrence: recurrence, isViewMode: isViewMode });
        if (!formattedEquipments.length) {
            return [];
        }
        return [{
                text: this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.EQUIPMENTS_WITHOUT_SECTOR_ENVIRONMENT'),
                icon: 'more_vertical',
                children: formattedEquipments,
                action: {
                    type: ActionTypeEnum.none
                }
            }];
    };
    TabLinksService.prototype.formatEnvironments = function (params) {
        var _this = this;
        var parent = params.parent, environments = params.environments, recurrence = params.recurrence, isViewMode = params.isViewMode;
        return (environments || []).map(function (environment) {
            var environmentItem = {
                id: environment.id,
                text: environment.name,
                description: environment.description,
                icon: 'environment',
                original: environment,
                archived: environment.archived,
                archivedText: _this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.ARCHIVED'),
                parent: parent,
                metadata: 'environment',
                action: {
                    type: ActionTypeEnum.menu,
                    buttons: [
                        {
                            text: _this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.MENU.VIEW_ENVIRONMENT'),
                            icon: 'wysiwyg',
                            color: '#676767',
                            action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.openLocationEnvironmentDialog(environment.id)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        },
                        {
                            text: _this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.MENU.UNLINK_ENVIRONMENT'),
                            icon: 'delete',
                            color: '#676767',
                            disabled: Boolean(recurrence && recurrence.id) || isViewMode,
                            action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    this.unlinkItem$.next({
                                        id: environment.id,
                                        formControlName: 'locationEnvironments'
                                    });
                                    return [2 /*return*/];
                                });
                            }); }
                        }
                    ]
                }
            };
            environmentItem.children = _this.formatEquipments({
                equipments: environment.equipments,
                parent: environmentItem,
                isViewMode: isViewMode,
                recurrence: recurrence
            });
            return environmentItem;
        });
    };
    TabLinksService.prototype.formatEquipments = function (params) {
        var _this = this;
        var equipments = params.equipments, parent = params.parent, recurrence = params.recurrence, isViewMode = params.isViewMode;
        return (equipments || []).map(function (equipment) { return ({
            id: equipment.id,
            text: equipment.name,
            description: equipment.number,
            archived: equipment.archived,
            archivedText: _this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.ARCHIVED'),
            icon: 'equipment',
            image: equipment.imageUrl,
            children: [],
            parent: parent,
            original: equipment,
            metadata: 'equipment',
            action: {
                type: ActionTypeEnum.menu,
                buttons: [
                    {
                        text: _this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.MENU.VIEW_EQUIPMENT'),
                        icon: 'wysiwyg',
                        color: '#676767',
                        action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.openEquipmentDialog(equipment.id)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    },
                    {
                        text: _this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.MENU.UNLINK_EQUIPMENT'),
                        icon: 'delete',
                        color: '#676767',
                        disabled: Boolean(recurrence && recurrence.id) || isViewMode,
                        action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                this.unlinkItem$.next({
                                    id: equipment.id,
                                    formControlName: 'newEquipments'
                                });
                                return [2 /*return*/];
                            });
                        }); }
                    }
                ]
            }
        }); });
    };
    TabLinksService.prototype.openLocationSectorDialog = function (locationSectorId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var locationSector, result, updatedValue;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.locationSectorApi.get(locationSectorId)];
                    case 1:
                        locationSector = _a.sent();
                        return [4 /*yield*/, this.matDialog
                                .open(DialogLocationSectorComponent, {
                                panelClass: 'dialog-location-sector',
                                data: {
                                    locationSector: locationSector
                                }
                            })
                                .afterClosed()
                                .toPromise()];
                    case 2:
                        result = _a.sent();
                        if (!(result && result.reload)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.locationSectorApi.get(locationSectorId)];
                    case 3:
                        updatedValue = _a.sent();
                        this.reloadItem$.next({
                            updatedValue: updatedValue,
                            formControlName: 'locationSectors'
                        });
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TabLinksService.prototype.openLocationEnvironmentDialog = function (locationEnvironmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var locationEnvironment, result, updatedValue;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.locationEnvironmentApi.get(locationEnvironmentId)];
                    case 1:
                        locationEnvironment = _a.sent();
                        locationEnvironment.location = locationEnvironment.locationSector.location;
                        return [4 /*yield*/, this.matDialog
                                .open(DialogLocationEnvironmentComponent, {
                                panelClass: 'dialog-location-environment',
                                data: {
                                    locationEnvironment: locationEnvironment,
                                }
                            })
                                .afterClosed()
                                .toPromise()];
                    case 2:
                        result = _a.sent();
                        if (!(result && result.reload)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.locationEnvironmentApi.get(locationEnvironmentId)];
                    case 3:
                        updatedValue = _a.sent();
                        this.reloadItem$.next({
                            updatedValue: updatedValue,
                            formControlName: 'locationEnvironments'
                        });
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TabLinksService.prototype.openEquipmentDialog = function (equipmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, updatedValue;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dialogEquipmentService.open({
                            equipmentId: equipmentId,
                            disableEditLocation: true
                        })];
                    case 1:
                        result = _a.sent();
                        if (!(result && result.reload)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.dialogEquipmentService.getEquipment({ equipmentId: equipmentId })];
                    case 2:
                        updatedValue = _a.sent();
                        this.reloadItem$.next({
                            updatedValue: updatedValue,
                            formControlName: 'newEquipments'
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TabLinksService.prototype.sortArchivedThenByName = function (a, b) {
        if (a.archived > b.archived) {
            return 1;
        }
        if (a.archived < b.archived) {
            return -1;
        }
        return a.name.localeCompare(b.name);
    };
    TabLinksService.prototype.filter = function (items, searchTerm) {
        var _this = this;
        searchTerm = (searchTerm || '').toLowerCase().trim();
        return items.filter(function (item) {
            if (item.children) {
                item.children = _this.filter(item.children, searchTerm);
            }
            var text = (item.text || '').toLowerCase();
            var description = (item.description || '').toLowerCase();
            return text.includes(searchTerm) || description.includes(searchTerm) || (item.children && item.children.length) || _this.parentMatch(item, searchTerm);
        });
    };
    TabLinksService.prototype.parentMatch = function (item, searchTerm) {
        if (!item.parent) {
            return false;
        }
        searchTerm = (searchTerm || '').toLowerCase().trim();
        var text = (item.parent.text || '').toLowerCase();
        var description = (item.parent.description || '').toLowerCase();
        return text.includes(searchTerm) || description.includes(searchTerm) || this.parentMatch(item.parent, searchTerm);
    };
    TabLinksService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TabLinksService_Factory() { return new TabLinksService(i0.ɵɵinject(i1.MatDialog), i0.ɵɵinject(i2.LocationSectorApi), i0.ɵɵinject(i3.LocationEnvironmentApi), i0.ɵɵinject(i4.DialogEquipmentService), i0.ɵɵinject(i5.TranslateService)); }, token: TabLinksService, providedIn: "root" });
    return TabLinksService;
}());
export { TabLinksService };
